<template lang="html">
  <v-dialog v-model="intDialogVisible" max-width="80%" class="addValueModal addComment" scrollable attach="body">
    <v-card>
      <div class="toptophead">
        <div class="startupName">
          {{vote.startup.name}}
        </div>
        <div class="interestLevel">
          <span class="high" v-if="vote.collab_interest_level == 'high' ">{{$t("high")}}</span>
          <span class="medium"  v-else-if="vote.collab_interest_level == 'medium' ">{{$t("Medium")}}</span>

          <span class="low"  v-else>{{$t("low")}}</span>

        </div>
        <div class="close" @click="close">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M2.85219 2.15L7.80219 7.1L12.7522 2.15C12.9522 1.95 13.2622 1.95 13.4622 2.15C13.6622 2.35 13.6622 2.66 13.4622 2.86L8.51219 7.8L13.4622 12.75C13.6622 12.95 13.6622 13.26 13.4622 13.46C13.2622 13.66 12.9522 13.66 12.7522 13.46L7.80219 8.51L2.85219 13.46C2.65219 13.66 2.34219 13.66 2.14219 13.46C1.94219 13.26 1.94219 12.95 2.14219 12.75L7.10219 7.8L2.15219 2.85C1.95219 2.66 1.95219 2.34 2.15219 2.15C2.34219 1.95 2.66219 1.95 2.85219 2.15Z" fill="#0A2071"/>
          </svg>

        </div>
      </div>

      <div class="infoStartup">
        <StartupHeader :startup="vote.startup" :isRestrict="false"/>
        <div class="mt50">
          <StartupInfoTab :startup="vote.startup" :isRestrict="false"/>

        </div>


        <div class="view" >
          <div class="assessment" >
            <div class="row">
              <div class="col-12 col-xl-4 mt20">
                <div class="item_card">
                  <span class="item_card_title">READINESS FOR PARTNERSHIP</span>
                  <div class="item_card_content"  v-if="vote.readiness_for_partnership">
                    <img :src="this.apiUrl+'/get_image/'+vote.readiness_for_partnership.$oid+'?token='+$store.state.innotoken" @click="visibleRef_readiness = true"  class="img-fluid" alt="">
                    <vue-easy-lightbox :rotateDisabled='true' :visible="visibleRef_readiness" :imgs="this.apiUrl+'/get_image/'+vote.readiness_for_partnership.$oid+'?token='+$store.state.innotoken"  @hide="onHide" ></vue-easy-lightbox>
                  </div>
                  <div class="item_card_content" v-else>
                    <div class="alert alert-info text-center">Not available</div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-xl-4 mt20">
                <div class="item_card">
                  <span class="item_card_title">ANALYTICAL SUPPORT</span>
                  <div class="item_card_content"  v-if="vote.analytical_support">
                    <img :src="this.apiUrl+'/get_image/'+vote.analytical_support.$oid+'?token='+$store.state.innotoken" @click="visibleRef_analytical_support = true"  class="img-fluid" alt="">
                    <vue-easy-lightbox :rotateDisabled='true' :visible="visibleRef_analytical_support" :imgs="this.apiUrl+'/get_image/'+vote.analytical_support.$oid+'?token='+$store.state.innotoken"  @hide="onHide" ></vue-easy-lightbox>
                  </div>
                  <div class="item_card_content" v-else>
                    <div class="alert alert-info text-center">Not available</div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-xl-4 mt20">
                <div class="item_card">
                  <span class="item_card_title">STRATEGIC FIT</span>
                  <div class="item_card_content" v-if="vote.strategic_fit">
                    <img :src="this.apiUrl+'/get_image/'+vote.strategic_fit.$oid+'?token='+$store.state.innotoken"  class="img-fluid assessment_report" alt="" @click="visibleRef_strategic_fit = true">
                    <vue-easy-lightbox :rotateDisabled='true' :visible="visibleRef_strategic_fit" :imgs="this.apiUrl+'/get_image/'+vote.strategic_fit.$oid+'?token='+$store.state.innotoken"  @hide="onHide"></vue-easy-lightbox>
                    </div>
                  <div class="item_card_content" v-else>
                    <div class="alert alert-info text-center">Not available</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt50"  v-if="vote.assessment_report">
              <div class="col-12 text-center">
                <a :href="this.apiUrl+'/get_image/'+vote.assessment_report.$oid+'?token='+$store.state.innotoken" target="_blank" class="changeImage_relative_outline" alt="" >
                  See the 360° assessment report
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
  </v-card>
  </v-dialog>

</template>


<script>
import StartupInfoTab from '@/components/StartupInfoTab.vue'
import StartupHeader from '@/components/StartupHeader.vue'




export default {
  name : "VoteNextStep",
  data(){
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      shownFeedback:null,
      detailsToogled:null,
      detailsVote: null,
      filtre: "",
    }
  },
  components:{
    StartupInfoTab,
    StartupHeader,

  },
  methods:{
    close(){
        this.$emit('close',false)
    },
    hideDetails(){
      this.shownFeedback = null;
    },
    showFeedBackBy(vote){
      this.shownFeedback = vote._id.$oid;
    },
    formattedNumber(number) {
          return new Intl.NumberFormat('fr-FR', {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 1
          }).format(number);
    },
    computedProgress(value) {
         // Make sure progress is between 0 and 100
         return Math.max(0, Math.min(100, (value / 5) * 100));
       },
       getGroupNameById(id) {
         console.log("search id:",id);
         console.log(this.criteriaGroups);
         var group = this.criteriaGroups.find(g => g._id.$oid == id);
         console.log("dinf ",group);
         return group ? group.name : null; // Return the groupname or null if not found
       },
       averageVotesByGroup(voting){
         const groupVotes = {};

        voting.forEach(item => {
            const groups = Array.isArray(item.details.group) ? item.details.group : [item.details.group];
            groups.forEach(group => {
              const groupId = group.$oid;

              // Initialize the group if it doesn't exist
              if (!groupVotes[groupId]) {
                groupVotes[groupId] = {
                  totalVotes: 0,
                  count: 0
                };
              }

              // Accumulate the votes for each group
              groupVotes[groupId].totalVotes += item.vote;
              groupVotes[groupId].count += 1;
            });
          });

          // Step 2: Calculate the average for each group
          const averageVotesByGroup = Object.keys(groupVotes).map(groupId => {
            return {
              groupId,
              averageVote: groupVotes[groupId].totalVotes / groupVotes[groupId].count
            };
          });
          return averageVotesByGroup;

       },
       criteriaByGroup(gid,voting) {
         var filteredCriteria = voting.filter(item => {
         // Check if 'group' is an array or a single object ID
         var groups = Array.isArray(item.details.group) ? item.details.group : [item.details.group];

         // Check if any of the groups match the groupId
         return groups.some(group => group.$oid === gid);
       });
       return filteredCriteria.filter(item => item.vote != null);
     },
     toogleDetails(gid,vid){
       this.detailsToogled = gid;
       this.detailsVote =  vid;
     },
     generateInitials(name) {
       const nameParts = name.trim().split(' ');

      // Check if there are at least two parts (first and last name)
      if (nameParts.length < 2) {
        // If there's only one name, return the first letter only
        return nameParts[0].charAt(0).toUpperCase();
      }

      // Get the first letter of the first word and the last word
      const firstInitial = nameParts[0].charAt(0).toUpperCase();  // First word initial
      const lastInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase(); // Last word initial

      // Return combined initials
      return `${firstInitial}${lastInitial}`;
    }
  },
  watch: {
    dialogVisible: function(){
      console.log("toto",this.vote);
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    },

  filterList() {
    var searchTerm = this.filtre.toLowerCase();

      const filteredCriteriaList = this.judgesVote.filter(item =>
        item.name.toLowerCase().includes(searchTerm)
      );

      const order = {
        high: 1,
        medium: 2,
        low: 3
      };

      console.log("filteredCriteriaList",filteredCriteriaList);

    return filteredCriteriaList.sort((a, b) => {
        return order[a.collab_interest_level] - order[b.collab_interest_level];
    });
  },
  },
  props: {
    dialogVisible: Boolean,
    vote: Object,
    assessment: Object,
    judgesVote : Array,
    criteriaGroups: Object,
  },
}
</script>

<style media="screen" scoped>

.details{
  position: absolute;
  background: #FFF;

  color: #000;
  bottom: 0;
  left: 0;
  z-index:99;
  transform: translateY(calc(100% + 10px));
  width:90%;
  box-shadow: 0px 4px 12px 2px rgba(0, 0, 0, 0.12);

}

.infoStartup{
  margin-left:50px;
  margin-right: 50px;
  margin-top:100px;
}

.mt50{
  margin-top:50px;
}
.oneJudgeVote{
  padding-top:20px;
  padding-bottom: 20px;

}


.voteDetail .detailsContent{

  display: flex;
  flex-direction: column;
  gap:20px;
  font-size:14px;
  line-height: 20px;
}

.voteDetail .value{
  display:flex;
  align-items: center;
  gap:10px;
}
.voteDetail .voteValue{
  font-weight: 100;
  font-size:32px;
  color:#0A2071;
  line-height: 35px;
}
.voteDetail .voteCriteria{
  color:#0A2071;
  font-size:16px;
  font-weight: 100;
}

.voteDetail .progress-bar {
  margin-top:10px;
  width: 100%;
  height: 8px; /* Adjust the height to match your example */
  background-color: #d3eaff; /* Light blue background color */
  border-radius: 4px; /* Rounded corners */
  overflow: hidden;
}

.voteDetail .progress-bar-fill {
  height: 100%;
  background-color: #4a90e2; /* Dark blue color */
  transition: width 0.3s ease; /* Smooth transition for progress */
  border-radius: 4px; /* To match the rounded corners */
}


.voteDetail .oneDetail.small .value{
  display:flex;
  justify-content:  space-between;
  gap:10px;

}
.voteDetail .oneDetail.small .voteValue{
  font-weight: 100;
  font-size:20px;
  color:#0A2071;
  line-height: 25px;
}
.oneDetail.small .voteCriteria{
  color:#0A2071;
  font-size:14px;
  font-weight: 400;
}

.voteDetail .oneDetail.small .progress-bar {
  margin-top:10px;
  width: calc(100% );
  height: 4px; /* Adjust the height to match your example */
  background-color: #d3eaff; /* Light blue background color */
  border-radius: 4px; /* Rounded corners */
  overflow: hidden;
}

.voteDetail .progress-bar-fill {
  height: 100%;
  background-color: #4a90e2; /* Dark blue color */
  transition: width 0.3s ease; /* Smooth transition for progress */
  border-radius: 4px; /* To match the rounded corners */
}
.voteDetail .progress-bar-fill-2 {
  height: 100%;
  background-color: #125AA4; /* Dark blue color */
  transition: width 0.3s ease; /* Smooth transition for progress */
  border-radius: 4px; /* To match the rounded corners */
}

.voteDetail .detail.small{
  margin-top:10px;
  display: flex;
  flex-direction: column;
  gap:10px;
}

.voteDetail .reverseTheSvg svg{
  transform:rotate(-180deg);
}

.voteDetail .voteCriteria small{
  font-weight: 200;
  font-size:12px;
}



.interestLevel .low{
  background:#FFE2E5;
  padding:4px 8px;
  font-size:14px;
  font-weight: 700;
  color:#FA5A7D;
  border-radius:20px;
}
.interestLevel .medium{
  background:#FFF4DE;
  padding:4px 8px;
  font-size:14px;
  font-weight: 700;
  color:#FFAA2A;
  border-radius:20px;
}
.interestLevel .high{
  background:#E7FFEF;
  padding:4px 8px;
  font-size:14px;
  font-weight: 700;
  color:#3AC851;
  border-radius:20px;
}

.head{
  display:flex;
  gap:10px;
  border-bottom:1px solid #125AA433;
  padding-bottom: 20px;
  align-items: center;
}
.judgeName{
  font-size:20px;
  color:#0A2071;
  font-weight: 300;
}

.userProfile{

  width: 40px;               /* Set a width */
height: 40px;              /* Set a height */
border-radius: 50%;         /* Make it circular */
background-color: #125AA4;  /* Background color */
color: white;               /* Text color */
display: flex;              /* Use flexbox for centering */
justify-content: center;    /* Center horizontally */
align-items: center;        /* Center vertically */
text-align: center;         /* Center text */
font-size: 16px;            /* Font size */
line-height: 1.2;

}


.oneJudgeVote .head{
  position:relative;
}

.listOfJudgesVotes{
  margin-bottom: 50px;
  display:flex;
  gap:50px;
}

.oneJudgeVote{
  width:calc(25% - 50px);
}

@media screen and (max-width:1500px){
  .oneJudgeVote{
    width:calc(33% - 50px);
  }
}

@media screen and (max-width:1250px){
  .oneJudgeVote{
    width:calc(50% - 50px);
  }
}


@media screen and (max-width:690px){
  .oneJudgeVote{
    width:100%;
  }
}

.searchForJudges .input_filtre{
  border:1px solid #E1E3E6;
  padding:10px;
  width:300px;
}

.searchForJudges{
  display:flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.resutlsLabel{
  font-size:14px;
  font-weight: 700;
}
.resultValue{
  font-size:14px;
  font-weight: 400;
  color:#73A7D6;
}

.counterResults{
  display:flex;
  gap:5px;
}


.toptophead{
  position:fixed;
  right:0px;
  top:0px;
  left:0;
  padding:20px;
  z-index: 99999;
  background:#FFF;
  display:flex;
  align-items: center;
  justify-content: space-between;
box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.toptophead > div{
  flex: 1;
}
.toptophead .interestLevel{text-align: center;}
.toptophead .startupName{
  font-size:25px;
  font-weight: 600;
  text-align:left;
}
.close{
  text-align:right;
    cursor:pointer;
}

.viewModeToggle{
  display:flex;
  justify-content: center;
  gap:0;
}
.viewModeToggle .viewModeBtn{
  padding:10px 30px;
  color:#FFF;
  background:#125AA4;
  font-size:16px;
  font-weight: 400;
}
.viewModeToggle .viewModeBtn.active{
  background:#3883C5;
}

.inner{
  margin-top:25px;
}

.subScoreTitle{
  color:#04246A;
  font-size:20px;
  font-weight:600;
}
.view{
  margin-top:25px;
  margin-bottom: 100px;
}
.scoreView{
  display:flex;
  flex-direction: column;
}

.scoreTitle{
  margin-bottom: 25px;
  color:#04246A;
  font-size:25px;
  font-weight:600;
}
.oneScore{
  padding-left:50px;
  padding-right: 50px;
}

.voteBtton{
  display:flex;
  gap:5px;
  align-items:center;
    cursor:pointer;
}



.assessment{
  margin-bottom: 100px;
}
.item_card{
  border: 1px solid #DDD;
  border-radius: 10px;
padding: 20px;
position:relative;
padding-top: 40px;
margin-top: 20px;
align-content: center;
align-items: center;
align-self: center;
justify-content: center;
display: flex;
height:100%;
}
.item_card .item_card_title{
  position:absolute;
  top: 0px;
  transform: translateY(-50%);
  left: 20px;
  background: #FFF;
  color: #3783C5;
text-transform: uppercase;
font-size:18px;
line-height: 24px;
  padding-left: 20px;
  padding-right: 20px;
}
</style>
